module.exports = __webpack_public_path__ + "img/building8.741ab533.jpg";